// extracted by mini-css-extract-plugin
export var artist = "spotify-module--artist--3VtSg";
export var content = "spotify-module--content--45plG";
export var heading = "spotify-module--heading--Ud80G";
export var name = "spotify-module--name--e9LRY";
export var number = "spotify-module--number--dFtnV";
export var spotify = "spotify-module--spotify--0xpUb";
export var tracks = "spotify-module--tracks--y1Ow-";